<script>
import resources from './resources'

export default {
  name: 'agenda-search-advanced',
  mixins: [resources]
}
</script>

<template lang="pug">
  page
    h2(slot="title")
      span.first-line
        span.icon 
        | Encontre um Profissional por Critérios Avançados
    .col-xs-12.content
      .container-fluid
        .row
          .nav-tabs-wrapper
            search-options
          .col-xs-12.white-bg
            .row
              .col-xs-12
                div.col-sm-10
                  .form-group(style='padding:30px 0px;')
                    .row
                      .form-group
                        v-input(:status="$v.agenda.professional.id.$error ? 'error' : null")
                          f-select-professional(
                            v-model="agenda.professional.id",
                            label="Nome ou CRM do Profissional que deseja encontrar?",
                            @selected="onSelectedProfessional")

                      .form-group(:class="{'has-error is-empty': $v.agenda.speciality.id.$error}")
                        f-select-speciality(
                          v-model="agenda.speciality.id",
                          label="Qual a Especialidade Médica ?",
                          @selected="onSelectedSpeciality",
                          v-if="!hiddenOptions")

                        f-select(
                          v-model="agenda.speciality.id",
                          label="Selecione uma Especialidade Médica do Profissional.",
                          :options="professionalSpecialityOptions",
                          @selected="onSelectedSpeciality",
                          labelBy="label",
                          v-if="hiddenOptions")

                        p.help-block(v-if='$v.agenda.speciality.id.$error')
                          strong(v-if='!$v.agenda.speciality.id.required')
                            | Selecione a especialidade

                      f-select-patient(
                        v-model="agenda.patient.id",
                        :value="agenda.patient.id",
                        label="Para quem é a Pesquisa?",
                        :get-all="true",
                        :searchable="false",
                        @selected="onSelectedPatient"
                      )

                      f-select(v-model="agenda.covenant_type", :options="covenantTypeOptions", label="Que tipo de Profissional deseja Encontrar?", :searchable="false")
                      .form-group(v-if="!agenda.covenant_type")
                        .row
                          .col-xs-12
                            label Qual a faixa de valores desejada para a Consulta Particular?
                          .col-xs-12.col-sm-4
                            f-numeric(
                              name="price_start"
                              :empty-value="0",
                              currency="R$",
                              :min="1",
                              :max="1000",
                              separator="."
                              :precision="2",
                              v-model='agenda.price_start',
                              placeholder="mínimo")

                          .col-xs-12.col-sm-4
                            f-numeric(
                              name="price_end"
                              :empty-value="0",
                              currency="R$",
                              :min="1",
                              :max="1000",
                              separator="."
                              :precision="2",
                              v-model='agenda.price_end',
                              placeholder="máximo")

                      .form-group
                        f-select(v-model="agenda.level_id", :options="levelOptions", label="Qual o nível de urgência")
                      .form-group(style='margin-top:30px;', v-if="agenda.level_id === 'others'")
                        .row
                          .col-xs-12.col-sm-4
                            label Data início
                            v-datepicker(
                              name="date_start",
                              v-model="agenda.date_start",
                              :config='config')
                            //-f-date(label="Data início", v-model="agenda.date_start")

                          .col-xs-12.col-sm-4
                            label Data final
                            v-datepicker(
                              name="date_end",
                              v-model="agenda.date_end",
                              :config='config')
                            //-f-date(label="Data fim", v-model="agenda.date_end")

                          .col-xs-12.col-sm-4
                            f-select(label="Período", v-model="agenda.period", :options="periodOptions")
                      .form-group
                        .row
                          .col-xs-12
                            f-select-address(
                              v-model="agenda.location.id",
                              label="Qual sua preferência de Localidade?",
                              :searchable="false",
                              :before-data="othersAddress",
                              @selected="checkLatitudeLongitude"
                            )
                      .form-group(v-if="agenda.location.id == 'all'")
                        .row
                          .col-xs-12
                            location-real-time
                        .row
                          //-.col-xs-8
                            f-zip(label="CEP", v-model="agenda.address.zip", name="label", @on-get-address="setAddress")
                          //-.col-xs-4
                              f-text(label="Número", v-model="agenda.address.number", name="number", :maxlength="6")
                        .row(v-if="agenda.address.street")
                          .col-xs-12
                            | {{ agenda.address.street }}
                            template(v-if="agenda.address.number")
                             | , {{ agenda.address.number }}
                            | , {{ agenda.address.district }}, {{ agenda.address.city }}/{{ agenda.address.state }}
                      .form-group
                        .row(v-if="agenda.location.id")
                          .col-xs-12
                            label(for='distancia') Qual a distância em Km de sua Busca?
                            .row
                              .col-xs-12.col-sm-10.margin-bottom
                                input#range-selector(v-model="agenda.location.distance", type='range', min='1', max='20', selection='before', value='2')
                              .col-xs-12.col-sm-2
                                f-number(v-model="agenda.location.distance", :min='1', :max='20', name='distancia')
                      .buttons-wrapper
                        button.btn.save(@click.prevent="doSearchByProfessionalSpeciality()")
                          span.icon 
                          |  Encontrar Profissional
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/advanced/agenda.vue